@if (endorsementLocation?.statusCode !== 'SIGNED') {
  <button
    class="signature-endorsement__button"
    [tabindex]="disableFocus ? -1 : 0"
    appDebounceClick
    (debouncedClick)="endorsementClicked()"
    [debounceTimer]="500"
    [hidden]="!endorsementLocation?.isSignableInCurrentSession"
  [attr.data-testid]="
    'endorsement-signature-' + this.endorsementLocation?.documentEndorsementLocationId
  "
    [disabled]="shouldDisable"
    >
    <div class="signature-endorsement__button__icon"></div>
    <div>Sign</div>
  </button>
} @else {
  <div
    class="signature-endorsement__image-wrapper"
    >
    <img
      [ngClass]="{
        'signature-endorsement__image': true,
        'signature-endorsement__image--hidden': hideIfSigned
      }"
      [src]="'data:image/png;base64,' + endorsementImage?.endorsementImage"
      alt="signature"
      [attr.data-testid]="
        'endorsement-signature-completed-' + this.endorsementLocation?.documentEndorsementLocationId
      "
      data-private
      />
      @if (endorsementLocation?.isSignableOnDevice && !shouldDisable) {
        <div
          class="signature-endorsement__erase-icon fa-solid fa-circle-xmark"
          appDebounceClick
          (debouncedClick)="eraseEndorsementClicked()"
          [debounceTimer]="500"
        ></div>
      }
    </div>
  }

